// removed by extract-text-webpack-plugin
module.exports = {"AccessoryInfoItem":"AccessoryInfoItem"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/accessory-info-item/styles.css
// module id = 875
// module chunks = 0 1